export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VerificaNoteDettaglioItem.vue?vue&type=template&id=87bd0566&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/VerificaNoteDettaglioItem.vue?vue&type=template&id=87bd0566&
// module id = 821
// module chunks = 0